import check from "check-types"
import { isEmptyValue } from "./checkValue"

/*
 * Build a minimal payload containing only the fields that really changed.
 *
 *   data         – the current form values
 *   initialData  – (optional) the values as they were when the form was first
 *                  loaded.  Pass an empty object for "add" forms.
 *
 * Behaviour:
 *   • Keeps booleans – so `false` updates work.
 *   • Keeps any key whose value differs from the initial one.
 *   • If the user cleared a field that previously contained a value, the field
 *     is included and converted to a backend-safe blank:
 *        – numbers / integers / FK → null
 *        – otherwise               → '' (empty string)
 *   • If initialData isn't supplied the function falls back to the original
 *     behaviour so existing "add" forms stay unchanged.
 */

export const excludeUnsetField = (data = {}, initialData = {}) => {
  check.assert.object(data);
  check.assert.object(initialData);

  const hasInitialData = Object.keys(initialData).length > 0;

  return Object.entries(data).reduce((acc, [key, currVal]) => {
    const prevVal = initialData[key];

    // If nothing changed, skip
    if (hasInitialData && currVal === prevVal) return acc;

    // For booleans we always include (needed to update false → true)
    if (check.boolean(currVal)) {
      acc[key] = currVal;
      return acc;
    }

    // Non-empty -> include as is
    if (!isEmptyValue(currVal)) {
      acc[key] = currVal;
      return acc;
    }

    // Empty value – include only if the field used to have data.
    if (hasInitialData && !isEmptyValue(prevVal)) {
      // Decide the safest blank representation: null for numeric / FK, '' otherwise
      const wasNumber = !isNaN(Number(prevVal)) && prevVal !== '';
      acc[key] = wasNumber ? null : '';
    }

    return acc;
  }, {});
}

// import check from "check-types"
// import { isEmptyValue } from "./checkValue"

// export const excludeUnsetField = (data={}) => {

//   check.assert.object(data);

//   return Object.entries(data)
//     .filter(([key, value]) => check.boolean(value) || !isEmptyValue(value))
//     .reduce((accum, [key, value]) => {
//       accum[key] = value
//       return accum
//     }, {})
// }
